<template>
  <div class="app-container">
    <el-container>
      <el-aside class="cbox-p14" width="240px">
        <div class="title">{{ detailData.projectName }}</div>

        <div class="info">
          <div class="label">委托编号：</div>
          <div class="value">{{ detailData.reportCodeStart }}</div>
        </div>
        <div class="info">
          <div class="label">委托单位：</div>
          <div class="value">{{ detailData.client }}</div>
        </div>
        <div class="info">
          <div class="label">委托单位联系人：</div>
          <div class="value">{{ detailData.sfcn }}</div>
        </div>
        <div class="info">
          <div class="label">委托单位联系方式：</div>
          <div class="value">{{ detailData.sfcp }}</div>
        </div>
        <div class="info">
          <div class="label">检测地点：</div>
          <div class="value">{{ detailData.testAddress }}</div>
        </div>
        <div class="info">
          <div class="label">使用车辆：</div>
          <div class="value">{{ detailData.supervisionUnit }}</div>
        </div>
        <el-divider />
        <div class="info">
          <div class="label">商定检测日期：</div>
          <div class="value">{{ detailData.sendDate }}</div>
        </div>
        <div class="info">
          <div class="label">客户备注：</div>
          <div class="value remark">{{ detailData.note }}</div>
        </div>
        <div class="info">
          <div class="label">内部备注：</div>
          <div class="value remark">{{ detailData.noteInner }}</div>
        </div>
        <el-divider />
        <div class="info">
          <div class="label">创建人：</div>
          <div class="value">{{ detailData.createByName }}</div>
        </div>
        <div class="info">
          <div class="label">创建时间：</div>
          <div class="value">{{ detailData.createtime }}</div>
        </div>
      </el-aside>
      <el-container>
        <el-main class="cbox-p14">
          <div class="table-main">
            <el-table ref="table" :data="tableData" stripe border style="width: 100%" height="100%" v-loading="tableLoading">
              <el-table-column prop="reportCode" label="报告编号" align="center" width="150"></el-table-column>
              <el-table-column prop="testItemText" label="检测项目" header-align="center" width="200"></el-table-column>
              <el-table-column prop="sampleCnt" label="样品数量" align="center" width="80"></el-table-column>
              <el-table-column prop="sampleCnt" label="试验项目" header-align="center">
                <template v-slot="{ row }">
                  <div style="white-space: pre-line">
                    {{ row.expItems }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="现场图片" header-align="center">
                <template v-slot="{ row }">
                  <div class="img-list">
                    <el-image
                      v-for="(url, imgIndex) in row.imgList"
                      :key="imgIndex"
                      style="width: 66px; height: 66px"
                      :src="url"
                      :preview-src-list="row.imgList"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="检测清单" header-align="center">
                <template v-slot="{ row }">
                  <div v-for="(file, index) in row.files" :key="index">
                    <el-link type="primary" :underline="true" :href="`${$imgUrl}${file.filePath}`" target="_blank">
                      {{ file.fileName }}
                    </el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="workRemark" label="工作量备注" header-align="center">
                <template v-slot="{ row }">
                  <div style="white-space: pre-line">
                    {{ row.workRemark }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="state" label="当前状态" align="center" width="120">
                <template v-slot="{ row }">
                  {{ row.state | stateFilter }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-main>
        <el-footer class="cbox-p14" height="54px">
          <el-button @click="$goBack()">关 闭</el-button>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { getEntrustmentSet, getEntrustmentList } from '@/api/entrust';

export default {
  components: {},
  props: {},
  data() {
    return {
      tableLoading: false,
      detailData: {},
      tableData: []
    };
  },
  filters: {
    stateFilter(state) {
      switch (state) {
        case 2:
        case 3:
          return '任务待分配';
        case -8:
        case -9:
        case 4:
        case 6:
          return '编制中';
        case 7:
          return '审核中';
        case 8:
          return '批准中';
        case 9:
          return '批准通过';
        default:
          return '编制中';
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    async getEntrustmentSet(id) {
      const { data } = await getEntrustmentSet({ id });
      this.detailData = data;
    },
    async getEntrustmentList(mainId) {
      const { data } = await getEntrustmentList({ mainId, pagesize: 900 });
      const tableData = data?.list || [];

      tableData.forEach(item => {
        // 赋值检测项目、工作量备注、试验项目、现场图片
        const sampleInfo = this.detailData.sampleInfoList.filter(sample => sample.entrustmentId === item.id)[0];
        item.testItemText = sampleInfo.testItemText;
        item.workRemark = sampleInfo.remark;
        item.expItems = sampleInfo.expItems;
        if (sampleInfo.imgs) {
          if (this.isJSONObjectOrArray(sampleInfo.imgs)) {
            const allFiles = JSON.parse(sampleInfo.imgs);
            item.imgs = allFiles.imgs;
            console.log('allFiles.imgs 打印:', allFiles.imgs);

            if (allFiles.imgs) {
              item.imgList = allFiles.imgs.split(',').map(item => {
                return this.$imgUrl + item;
              });
            }
            item.files = allFiles?.files || [];
          } else {
            item.imgs = sampleInfo.imgs;
            item.imgList = sampleInfo.imgs.split(',').map(item => {
              return this.$imgUrl + item;
            });
            item.files = [];
          }
        } else {
          item.imgs = '';
          item.files = [];
        }
      });
      this.tableData = tableData;
    },
    isJSONObjectOrArray(str) {
      if (typeof str !== 'string') return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    }
  },
  created() {},
  mounted() {},
  async activated() {
    const entrustmentSetId = this.$route.params.id;
    await this.getEntrustmentSet(entrustmentSetId);
    this.getEntrustmentList(entrustmentSetId);
  }
};
</script>
<style lang="scss" scoped>
.el-container {
  height: 100%;
}
.el-aside {
  height: 100%;
  margin-right: 10px;

  .title {
    position: relative;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4em;
    text-indent: 6px;

    &::after {
      position: absolute;
      content: '';
      left: 0;
      top: 11px;
      transform: translateY(-10px);
      width: 4px;
      height: 20px;
      background: #009688;
    }
  }

  .info {
    margin-bottom: 10px;
    line-height: 1.4em;
    font-size: 14px;

    .label {
      display: inline-block;
      color: #666666;
    }
    .value {
      color: #333333;
    }
    .remark {
      padding: 4px;
      margin-top: 2px;
      background-color: #f2f2f2;
      color: #606266;
      border-radius: 4px;
    }
  }
}
.el-main {
  height: calc(100% - 64px);
}
.el-table {
  .el-button--medium {
    padding: 0;
  }
}
.el-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}

.img-list {
  width: 100%;
  overflow: hidden;
  overflow-x: auto;

  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}
</style>
